import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "./api";

export function useCrud(col) {
  const qc = useQueryClient();
  const refresh = () => qc.invalidateQueries();
  const save = async (item, silent) => {
    try {
      const { id, created_at, updated_at, ...data } = item;
      const r = id ? await api.put(`/admin/c/${col}/${id}`, data) : await api.post(`/admin/c/${col}`, data);
      if (!silent) toast.success("Kaydedildi");
      refresh();
      return r.data;
    } catch (e) { toast.error(errMsg(e)); return null; }
  };
  const remove = async (id, label = "Bu öğe") => {
    if (!window.confirm(`${label} silinsin mi?`)) return false;
    try { await api.delete(`/admin/c/${col}/${id}`); toast.success("Silindi"); refresh(); return true; }
    catch (e) { toast.error(errMsg(e)); return false; }
  };
  const reorder = async (items) => {
    qc.setQueryData(["admin", col], (old) => {
      if (!old) return old;
      const order = Object.fromEntries(items.map((it, i) => [it.id, i]));
      return [...old].map((o) => (o.id in order ? { ...o, order: order[o.id] } : o)).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    });
    try { await api.post(`/admin/c/${col}/reorder`, { items: items.map((it, i) => ({ id: it.id, order: i, ...(it.parent_id !== undefined && { parent_id: it.parent_id }) })) }); refresh(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return { save, remove, reorder };
}
